<template>
  <div class="bb-credit-notes">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <Table :options="tableOptions" :min-height="1500" ref="bbCreditNotes" :stop-scroll-up="stopTableScrollUp"/>
    <Pagination :data="fullInfoCredits" :getQuery="getCreditNotes" :limit="defLimit" class="bb-pagination"/>
  </div>
</template>

<script>
import {creditNotesTable, creditNotesTableColumns} from '@/constants/TablesOptions/creditNotesTable'
import Table from '@/components/Main/Table/Table'
import CreditNotesApi from '@/api/CreditNotes/api'
import UploadFileApi from '@/api/UploadFile/api'
import ContactsApi from '@/api/Contacts/api'
import _ from 'lodash'
import Pagination from '@/components/Main/Pagination/Pagination'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import moment from 'moment'
import b64toBlob from 'b64-to-blob'
import {saveAs} from 'file-saver'

export default {
  name: 'CreditNotes',
  props: ['filterClientId', 'newEntry'],
  components: {
    Table,
    Pagination,
    LoaderFly

  },
  data () {
    return {
      filterByConsumed: {
        consumed: false,
        notConsumed: false
      },
      filterByClient: '',
      uploadFiles: [],
      tableOptions: creditNotesTable,
      filterByDate: '',
      sort: 'sort[]=date&sort=-1',
      defLimit: 30,
      fullInfoCredits: '',
      loaderRun: false,
      stopTableScrollUp: false,
      crypt: true,
      files: {}
    }
  },
  computed: {
    creditNotesColumnsData: {
      get: function () {
        return this.$store.getters.creditNotesColumnsData
      },
      set: function (data) {
        this.$store.dispatch('setCreditNotesColumnsData', data)
      }
    },
    creditNotesRowsData: {
      get: function () {
        return this.$store.getters.creditNotesRowsData
      },
      set: function (data) {
        this.$store.dispatch('setCreditNotesRowsData', data)
      }
    },
    contactsList: {
      get: function () {
        return this.$store.getters.contactsList
      },
      set: function (data) {
        this.$store.dispatch('setContactsList', data)
      }
    }
  },
  methods: {
    newCreditNote () {
      const creditNote = {
        amount: 0,
        date: new Date(),
        consumed: false,
        newMode: true,
        create: this.createCreditNotes,
        consumedInvoice: [
          {
            consumedComment: '',
            consumedAmount: 0,
            uploadFile: []
          }
        ]
      }
      const newHave = _.find(this.creditNotesRowsData, {newMode: true})
      if (newHave) {
        return
      }
      this.creditNotesRowsData.unshift(creditNote)
    },
    setFilter (data, item, property) {
      item.id ? this.filterByConsumed.consumed = data : this.filterByConsumed.notConsumed = data
      this.getCreditNotes({})
    },
    addActions () {
      _.forEach(this.creditNotesColumnsData, item => {
        if (item.sort) {
          item.get = this.getCreditNotes
        }
        if (item.actions) {
          item.actions.delete = this.deleteCreditNotes
          item.actions.edit = this.editCreateNotes
          item.actions.getFile = this.openFile
          item.actions.uploadFile = this.uploadAllFiles
          item.actions.deleteFile = this.deleteFile
          item.actions.filter = this.setFilter
        }
      })
    },
    uploadAllFiles (files, row, rows, copyRow) {
      _.forEach(files, file => {
        this.uploadFile(this.setFileData(file), row, rows, copyRow)
      })
    },
    getContactsList () {
      this.loaderRun = true
      const query = 'sort[]=nickName'
      ContactsApi.getContactsList({limit: 1000, query})
        .then((resp) => {
          resp.data.clients = _.filter(resp.data.clients, item => item)
          this.contactsList = resp.data.clients
          this.creditNotesColumnsData.forEach(item => {
            if (item.listName === 'clientsList') {
              item.list = resp.data.clients
            }
          })
          this.$emit('setQuery', this.getCreditNotes)
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    getFilterByConsumed () {
      const values = Object.values(this.filterByConsumed)
      const allChecked = values.every(val => val === true)
      const allUnchecked = values.every(val => val === false)
      if (allChecked || allUnchecked) {
        return ''
      } else if (this.filterByConsumed.consumed) {
        return 'consumed[]=true'
      } else if (this.filterByConsumed.notConsumed) {
        return 'consumed[]=false'
      }
    },
    scrollUp () {
      const table = _.get(this, '$refs.bbCreditNotes.$el', false)
      const parentScroll = _.get(this, '$root.$children[0].$refs.rightPanel.$el', false)
      if (table && parentScroll) {
        const positionTop = _.get(table.getBoundingClientRect(), 'top', 0)
        const topWithScroll = parentScroll.scrollTop + positionTop
        const scrollTo = topWithScroll - 58
        parentScroll.scrollTop = scrollTo
      }
    },
    getCreditNotes ({filter, limit = this.defLimit, page, query}) {
      if (!this.stopTableScrollUp) this.scrollUp()
      this.loaderRun = true
      if (filter) {
        this.filterByDate = `date=${filter}`
      }
      const consumed = this.getFilterByConsumed()
      const sort = query || 'sort[]=notesNumber&sort[]=-1'
      const fullQuery = {
        limit: limit,
        page: page,
        sort: sort,
        filterByConsumed: consumed,
        filterByDate: this.filterByDate,
        filterByClient: this.filterByClient
      }
      CreditNotesApi.getCreditNotes(fullQuery)
        .then((resp) => {
          this.fullInfoCredits = resp.data
          this.creditNotesRowsData = resp.data.creditnotes.map(item => {
            if (item.uploadFile) {
              item.uploadFile = [item.uploadFile]
            }
            return item
          })
          this.addActions()
          this.loaderRun = false
          this.stopTableScrollUp = false
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
          this.stopTableScrollUp = false
        })
    },
    sortDates (a, b) {
      return moment(b.date).format('YYYYMMDD') - moment(a.date).format('YYYYMMDD')
    },
    setCommentsFiles (creditNote) {
      const clientId = _.get(creditNote, 'clientName.id', '')
      if (typeof creditNote.clientName === 'object' && !clientId) delete creditNote.clientName
      if (typeof creditNote.clientName === 'object' && clientId) creditNote.clientName = clientId
      creditNote.consumedInvoice.forEach(comment => {
        if (comment.uploadFile) {
          comment.uploadFile = comment.uploadFile.map(file => {
            return file.id || file._id
          })
        }
      })
    },
    createCreditNotes (creditNote) {
      this.setCommentsFiles(creditNote)
      creditNote.uploadFile = this.uploadFiles.map(item => item.id)
      if (creditNote.uploadFile.length === 0) delete creditNote.uploadFile
      creditNote.notesNumber = _.trim(creditNote.notesNumber)
      CreditNotesApi.createCreditNotes(creditNote)
        .then(() => {
          this.uploadFiles = []
          this.getCreditNotes({})
        })
        .catch((err) => {
          console.error(err)
        })
    },
    editCreateNotes (creditNote) {
      this.setCommentsFiles(creditNote)
      const originalIndex = _.findIndex(this.creditNotesRowsData, {id: creditNote.id})
      if (originalIndex !== -1 && this.uploadFiles.length === 0) {
        const files = _.get(this.creditNotesRowsData[originalIndex], 'uploadFile', [])
        this.uploadFiles = files || []
      }
      creditNote.uploadFile = this.uploadFiles.map(item => item.id)
      if (creditNote.uploadFile.length === 0) delete creditNote.uploadFile
      creditNote.notesNumber = _.trim(creditNote.notesNumber)
      CreditNotesApi.editCreditNotes(creditNote)
        .then(() => {
          this.uploadFiles = []
          this.stopTableScrollUp = true
          this.getCreditNotes({})
        })
        .catch((err) => {
          console.error(err)
        })
    },
    deleteCreditNotes (IdCreditNote) {
      const index = _.findIndex(this.creditNotesRowsData, {id: IdCreditNote})
      CreditNotesApi.deleteCreditNotes(IdCreditNote)
        .then((resp) => {
          this.creditNotesRowsData.splice(index, 1)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    uploadFile (fileData, row, rows, copyRow) {
      const index = _.findIndex(rows, {id: row.id})
      UploadFileApi.createFile(fileData, this.crypt)
        .then((resp) => {
          this.uploadFiles = [resp.data]
          row = _.cloneDeep(copyRow)
          row.uploadFile = [resp.data]
          if (index !== -1) {
            rows.splice(index, 1, row)
          } else if (row.newMode) {
            rows.splice(0, 1, row)
          }
        })
        .catch((err) => {
          row.uploadFile = []
          console.error(err)
        })
    },
    openFile (file) {
      this.files[file.id] ? saveAs(this.files[file.id].blob, this.files[file.id].label) : this.getFile(file)
    },
    getFile (file) {
      this.loaderRun = true
      UploadFileApi.getFile(file.id, this.crypt)
        .then((resp) => {
          const blob = b64toBlob(resp.data.base64, resp.data.type)
          this.files[resp.data.id] = {id: resp.data.id, blob, label: resp.data.label}
          saveAs(blob, resp.data.label)
          this.loaderRun = false
        })
        .catch((err) => {
          console.error(err)
          this.loaderRun = false
        })
    },
    deleteFile (id, row, rows, copyRow) {
      const index = _.findIndex(rows, {id: row.id})
      UploadFileApi.deleteFile(id, this.crypt)
        .then((resp) => {
          row = _.cloneDeep(copyRow)
          const oldFile = row.uploadFile || []
          const indexFile = _.findIndex(oldFile, {id: id})
          if (indexFile !== -1) oldFile.splice(indexFile, 1)
          if (index !== -1) {
            rows.splice(index, 1, row)
          } else if (row.newMode) {
            rows.splice(0, 1, row)
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setFileData (file) {
      const fileData = new FormData()
      fileData.set('fieldname', 'uploadFile')
      fileData.set('label', file.name || '')
      fileData.set('file', file)
      return fileData
    }
  },
  watch: {
    filterClientId () {
      this.filterByClient = this.filterClientId ? `&clientName[]=${this.filterClientId}` : ''
      this.getCreditNotes({})
    },
    newEntry () {
      if (this.newEntry) this.newCreditNote()
    }
  },
  beforeMount () {
    this.creditNotesColumnsData = creditNotesTableColumns
    this.getContactsList()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

.bb-credit-notes {
  min-width: 1350px;
}

</style>



// WEBPACK FOOTER //
// src/components/Finance/InvoiceTable/CreditNotes/CreditNotes.vue